<template>
  <div class="mobile-nav" id="mobile-nav">
    <div class="mobile-nav__close-btn" @click="$emit('onCloseMobileNav')"></div>

    <ul class="mobile-nav-block">
      <li class="mobile-nav__item">
        <router-link
          :to="{name: 'home'}"
          class="mobile-nav__link"
          @click.native="$emit('onCloseMobileNav')"
        >О Компании</router-link>
      </li>
      <li class="mobile-nav__item">
        <router-link
          :to="{name: 'category', params: {id: 'stone'}}"
          class="mobile-nav__link"
          @click.native="$emit('onCloseMobileNav')"
        >Щебень</router-link>
      </li>
      <li class="mobile-nav__item">
        <router-link
          :to="{name: 'category', params: {id: 'sand'}}"
          class="mobile-nav__link"
          @click.native="$emit('onCloseMobileNav')"
        >Отсев</router-link>
      </li>
      <li class="mobile-nav__item">
        <router-link
          :to="{name: 'certificates'}"
          class="mobile-nav__link"
          @click.native="$emit('onCloseMobileNav')"
        >Сертификаты</router-link>
      </li>
      <li class="mobile-nav__item">
        <router-link
          :to="{name: 'contacts'}"
          class="mobile-nav__link"
          @click.native="$emit('onCloseMobileNav')"
        >Контакты</router-link>
      </li>
      <li class="mobile-nav__item">
        <a :href="pricelist" target="_blank" class="mobile-nav__link">
          <ButtonSlider msg="Прайс-лист" theme="header-btn"/>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { TweenMax } from "gsap/TweenMax";
import ButtonSlider from "@/components/ButtonSlider.vue";

import { mapGetters } from "vuex";

export default {
  name: "MobileNav",
  components: { ButtonSlider },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  watch: {
    isOpen: function(newVal, oldVal) {
      if (newVal === true) {
        TweenMax.to("#mobile-nav", 0.5, { top: 0, opacity: 1, zIndex: 5 });
      } else {
        TweenMax.to("#mobile-nav", 0.5, { top: -999, opacity: 0, zIndex: -5 });
      }
    }
  },
  computed: {
    ...mapGetters("pricelist", ["pricelist"])
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/settings.scss";

.mobile-nav {
  position: fixed;
  top: -999px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  font-size: 2rem;
  z-index: -5;
  opacity: 0;
}
.mobile-nav-block {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  width: 100%;
  margin: 0;
  padding: 0;
}
.mobile-nav__item {
  list-style-type: none;
}
.mobile-nav__link {
  color: $white-color;
  display: block;
  padding: 15px;
  text-align: center;
}
.mobile-nav__link:hover {
  color: $white-color;
  text-decoration: none;
}
.mobile-nav__close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 22px;
  height: 22px;
  background: url(../assets/hamburg-menu-close.svg) no-repeat center center;
}
</style>
